import React, { useState } from "react";
import { Card, Row, Col, Badge, Table, Button, Form, Dropdown } from "react-bootstrap";
import {
  FileText,
  RotateCw,
  AlertCircle,
  CreditCard,
  Download,
  Settings,
  Eye,
  Mail,
  Calendar,
  Filter,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  Info,
} from "lucide-react";

// Mock Data for Subscription History
const SUBSCRIPTION_HISTORY = [
  {
    id: 1,
    prtCode: "PRT-1001",
    name: "Royal Events",
    logo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&auto=format&fit=crop&q=80",
    plan: "Professional",
    planType: "professional",
    startDate: "01 May 2025",
    endDate: "30 Apr 2026",
    amount: "₹2,45,000",
    status: "Active",
  },
  {
    id: 2,
    prtCode: "PRT-1002",
    name: "Elite Weddings",
    logo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80",
    plan: "Enterprise",
    planType: "enterprise",
    startDate: "15 Feb 2025",
    endDate: "14 Feb 2026",
    amount: "₹5,60,000",
    status: "Active",
  },
  {
    id: 3,
    prtCode: "PRT-1003",
    name: "Dream Shaadi Co.",
    logo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&q=80",
    plan: "Starter",
    planType: "starter",
    startDate: "10 Apr 2025",
    endDate: "09 Apr 2026",
    amount: "₹75,000",
    status: "Active",
  },
  {
    id: 4,
    prtCode: "PRT-1004",
    name: "Shaadi Makers",
    logo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=80",
    plan: "Professional",
    planType: "professional",
    startDate: "20 May 2025",
    endDate: "19 May 2026",
    amount: "₹1,80,000",
    status: "Due Soon",
  },
  {
    id: 5,
    prtCode: "PRT-1005",
    name: "Celebrations Co.",
    logo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&auto=format&fit=crop&q=80",
    plan: "Starter",
    planType: "starter",
    startDate: "05 Mar 2025",
    endDate: "04 Mar 2026",
    amount: "₹35,000",
    status: "Active",
  },
];

// Mock Data for Upcoming Renewals
const UPCOMING_RENEWALS = [
  {
    id: 1,
    name: "Royal Events",
    logo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&auto=format&fit=crop&q=80",
    plan: "Professional",
    planType: "professional",
    dueDate: "30 Apr 2026",
    amount: "₹2,45,000",
    daysLeft: "15 days",
  },
  {
    id: 2,
    name: "Shaadi Makers",
    logo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=80",
    plan: "Professional",
    planType: "professional",
    dueDate: "19 May 2026",
    amount: "₹1,80,000",
    daysLeft: "34 days",
  },
  {
    id: 3,
    name: "Dream Shaadi Co.",
    logo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&auto=format&fit=crop&q=80",
    plan: "Starter",
    planType: "starter",
    dueDate: "09 Apr 2026",
    amount: "₹75,000",
    daysLeft: "55 days",
  },
  {
    id: 4,
    name: "Milan Events",
    logo: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=80",
    plan: "Starter",
    planType: "starter",
    dueDate: "22 Apr 2026",
    amount: "₹35,000",
    daysLeft: "68 days",
  },
  {
    id: 5,
    name: "Elite Weddings",
    logo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=80",
    plan: "Enterprise",
    planType: "enterprise",
    dueDate: "14 Feb 2026",
    amount: "₹5,60,000",
    daysLeft: "96 days",
  },
];

// Mock Data for Outstanding Payments
const OUTSTANDING_PAYMENTS = [
  {
    id: 1,
    name: "Elite Weddings",
    invoiceNo: "INV-2025-212",
    dueDate: "20 May 2025",
    amount: "₹2,40,000",
    status: "Overdue",
  },
  {
    id: 2,
    name: "Shaadi Makers",
    invoiceNo: "INV-2025-211",
    dueDate: "18 May 2025",
    amount: "₹1,20,000",
    status: "Overdue",
  },
  {
    id: 3,
    name: "Royal Events",
    invoiceNo: "INV-2025-205",
    dueDate: "25 May 2025",
    amount: "₹1,10,000",
    status: "Due Soon",
  },
  {
    id: 4,
    name: "Celebrations Co.",
    invoiceNo: "INV-2025-207",
    dueDate: "28 May 2025",
    amount: "₹70,000",
    status: "Due Soon",
  },
  {
    id: 5,
    name: "Dream Shaadi Co.",
    invoiceNo: "INV-2025-210",
    dueDate: "30 May 2025",
    amount: "₹40,000",
    status: "Due Soon",
  },
];

// Mock Data for Invoices
const INVOICES_LIST = [
  {
    id: 1,
    invoiceNo: "INV-2025-220",
    name: "Royal Events",
    invoiceDate: "01 May 2025",
    dueDate: "31 May 2025",
    amount: "₹2,45,000",
    status: "Paid",
  },
  {
    id: 2,
    invoiceNo: "INV-2025-219",
    name: "Elite Weddings",
    invoiceDate: "15 May 2025",
    dueDate: "14 Jun 2025",
    amount: "₹2,40,000",
    status: "Paid",
  },
  {
    id: 3,
    invoiceNo: "INV-2025-218",
    name: "Dream Shaadi Co.",
    invoiceDate: "10 May 2025",
    dueDate: "09 Jun 2025",
    amount: "₹75,000",
    status: "Sent",
  },
  {
    id: 4,
    invoiceNo: "INV-2025-217",
    name: "Shaadi Makers",
    invoiceDate: "20 May 2025",
    dueDate: "19 Jun 2025",
    amount: "₹1,80,000",
    status: "Overdue",
  },
  {
    id: 5,
    invoiceNo: "INV-2025-216",
    name: "Celebrations Co.",
    invoiceDate: "05 May 2025",
    dueDate: "04 Jun 2025",
    amount: "₹35,000",
    status: "Paid",
  },
];

export default function PartnerBilling() {
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState("All Status");
  const [dateRange, setDateRange] = useState("01 May 2025 - 31 May 2025");

  const getPlanBadgeStyle = (planType) => {
    switch (planType) {
      case "enterprise":
        return { backgroundColor: "#dbeafe", color: "#1d4ed8" };
      case "professional":
        return { backgroundColor: "#f3e8ff", color: "#7e22ce" };
      case "starter":
      default:
        return { backgroundColor: "#dcfce7", color: "#15803d" };
    }
  };

  const getStatusBadgeStyle = (status) => {
    switch (status) {
      case "Paid":
      case "Active":
        return { backgroundColor: "#dcfce7", color: "#15803d" };
      case "Sent":
        return { backgroundColor: "#dbeafe", color: "#1d4ed8" };
      case "Due Soon":
        return { backgroundColor: "#fef3c7", color: "#b45309" };
      case "Overdue":
        return { backgroundColor: "#fee2e2", color: "#dc2626" };
      default:
        return { backgroundColor: "#f1f5f9", color: "#475569" };
    }
  };

  return (
    <div className="p-2 p-md-4" style={{ backgroundColor: "#fafaf9", minHeight: "100vh" }}>
      {/* Top Title & Header Actions */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
        <div>
          <h2 className="fw-extrabold mb-1" style={{ color: "#800001", letterSpacing: "-0.03em" }}>
            Billing Center
          </h2>
          <p className="text-muted mb-0 small fw-bold" style={{ color: "#64748b" }}>
            Manage partner subscriptions, renewals, payments and invoices.
          </p>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Button
            variant="outline-danger"
            className="d-flex align-items-center gap-2 fw-extrabold shadow-sm bg-white"
            style={{
              borderColor: "#800001",
              color: "#800001",
              borderRadius: "0.6rem",
              padding: "0.45rem 1rem",
              fontSize: "0.85rem",
            }}
          >
            <Download size={16} /> Export Report
          </Button>

          <Button
            variant="outline-danger"
            className="d-flex align-items-center gap-2 fw-extrabold shadow-sm bg-white"
            style={{
              borderColor: "#800001",
              color: "#800001",
              borderRadius: "0.6rem",
              padding: "0.45rem 1rem",
              fontSize: "0.85rem",
            }}
          >
            <Settings size={16} /> Billing Settings
          </Button>
        </div>
      </div>

      {/* Top 4 Metric KPI Cards */}
      <Row className="g-3 mb-4">
        {/* Card 1: Total Revenue */}
        <Col sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "48px", height: "48px", backgroundColor: "#f3e8ff", color: "#9333ea" }}
                  >
                    <FileText size={22} />
                  </div>
                </div>
                <div className="fw-extrabold text-muted small d-flex align-items-center gap-1 mb-1">
                  Total Revenue <Info size={14} className="text-muted" />
                </div>
                <h3 className="fw-extrabold mb-2" style={{ color: "#0f172a", fontSize: "1.75rem" }}>
                  ₹52,45,000
                </h3>
                <div className="fw-bold small d-flex align-items-center gap-1 mb-3" style={{ color: "#16a34a" }}>
                  ↑ 18% <span style={{ color: "#64748b" }}>vs last 30 days</span>
                </div>
              </div>
              <a
                href="#revenue-report"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                style={{ color: "#800001" }}
              >
                View Revenue Report <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 2: Renewals Due */}
        <Col sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "48px", height: "48px", backgroundColor: "#dcfce7", color: "#16a34a" }}
                  >
                    <RotateCw size={22} />
                  </div>
                </div>
                <div className="fw-extrabold text-muted small d-flex align-items-center gap-1 mb-1">
                  Renewals Due <Info size={14} className="text-muted" />
                </div>
                <h3 className="fw-extrabold mb-2" style={{ color: "#0f172a", fontSize: "1.75rem" }}>
                  12
                </h3>
                <div className="fw-bold small mb-3" style={{ color: "#ea580c" }}>
                  Next 30 days
                </div>
              </div>
              <a
                href="#renewals"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                style={{ color: "#800001" }}
              >
                View Renewals <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 3: Outstanding Payments */}
        <Col sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "48px", height: "48px", backgroundColor: "#ffedd5", color: "#ea580c" }}
                  >
                    <AlertCircle size={22} />
                  </div>
                </div>
                <div className="fw-extrabold text-muted small d-flex align-items-center gap-1 mb-1">
                  Outstanding Payments <Info size={14} className="text-muted" />
                </div>
                <h3 className="fw-extrabold mb-2" style={{ color: "#0f172a", fontSize: "1.75rem" }}>
                  ₹6,80,000
                </h3>
                <div className="fw-bold small mb-3" style={{ color: "#ea580c" }}>
                  18 Invoices
                </div>
              </div>
              <a
                href="#outstanding"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                style={{ color: "#800001" }}
              >
                View Outstanding <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 4: Paid Invoices */}
        <Col sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "48px", height: "48px", backgroundColor: "#ede9fe", color: "#6d28d9" }}
                  >
                    <CreditCard size={22} />
                  </div>
                </div>
                <div className="fw-extrabold text-muted small d-flex align-items-center gap-1 mb-1">
                  Paid Invoices <Info size={14} className="text-muted" />
                </div>
                <h3 className="fw-extrabold mb-2" style={{ color: "#0f172a", fontSize: "1.75rem" }}>
                  265
                </h3>
                <div className="fw-bold small mb-3" style={{ color: "#16a34a" }}>
                  This Year
                </div>
              </div>
              <a
                href="#invoices"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                style={{ color: "#800001" }}
              >
                View All Invoices <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Main Grid: Left Section & Right Section */}
      <Row className="g-4 mb-4">
        {/* Left Column: Subscription History & Invoices */}
        <Col lg={7}>
          {/* Subscription History Card */}
          <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FileText size={20} style={{ color: "#800001" }} />
                  <h5 className="fw-extrabold mb-0" style={{ color: "#0f172a" }}>
                    Subscription History
                  </h5>
                </div>
                <a
                  href="#history"
                  className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                  style={{ color: "#800001" }}
                >
                  View All History <ArrowRight size={14} />
                </a>
              </div>

              <Table responsive borderless className="align-middle mb-3">
                <thead>
                  <tr className="border-bottom text-muted small" style={{ fontSize: "0.78rem" }}>
                    <th className="py-2 px-2">Partner Name</th>
                    <th className="py-2 px-2">Plan</th>
                    <th className="py-2 px-2">Start Date</th>
                    <th className="py-2 px-2">End Date</th>
                    <th className="py-2 px-2">Amount</th>
                    <th className="py-2 px-2">Status</th>
                    <th className="py-2 px-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {SUBSCRIPTION_HISTORY.map((item) => (
                    <tr key={item.id} className="border-bottom">
                      <td className="py-3 px-2">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={item.logo}
                            alt={item.name}
                            className="rounded-circle object-fit-cover"
                            style={{ width: "36px", height: "36px", border: "1.5px solid #F8DBA0" }}
                          />
                          <div>
                            <div className="fw-extrabold mb-0" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                              {item.name}
                            </div>
                            <span className="text-muted fw-bold small" style={{ fontSize: "0.72rem" }}>
                              {item.prtCode}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="py-3 px-2">
                        <Badge
                          className="px-2 py-1 fw-bold"
                          style={{ borderRadius: "50rem", fontSize: "0.72rem", ...getPlanBadgeStyle(item.planType) }}
                        >
                          {item.plan}
                        </Badge>
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.8rem" }}>
                        {item.startDate}
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.8rem" }}>
                        {item.endDate}
                      </td>
                      <td className="py-3 px-2 fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.amount}
                      </td>
                      <td className="py-3 px-2">
                        <Badge
                          className="px-3 py-1 fw-bold"
                          style={{ borderRadius: "50rem", fontSize: "0.72rem", ...getStatusBadgeStyle(item.status) }}
                        >
                          {item.status}
                        </Badge>
                      </td>
                      <td className="py-3 px-2 text-center">
                        <Button
                          variant="white"
                          size="sm"
                          className="rounded-circle p-1 d-inline-flex align-items-center justify-content-center shadow-sm"
                          style={{ width: "32px", height: "32px", borderColor: "#e2e8f0", color: "#800001" }}
                        >
                          <Eye size={15} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Pagination */}
              <div className="d-flex align-items-center justify-content-between pt-2">
                <span className="text-muted small fw-bold" style={{ fontSize: "0.78rem" }}>
                  Showing 1 to 5 of 420 records
                </span>
                <div className="d-flex align-items-center gap-1">
                  <Button variant="light" size="sm" className="p-1 rounded text-muted">
                    <ChevronLeft size={16} />
                  </Button>
                  <Button size="sm" className="px-2 py-1 rounded fw-extrabold text-white" style={{ backgroundColor: "#800001", borderColor: "#800001" }}>
                    1
                  </Button>
                  <Button variant="light" size="sm" className="px-2 py-1 rounded fw-bold text-muted">
                    2
                  </Button>
                  <Button variant="light" size="sm" className="px-2 py-1 rounded fw-bold text-muted">
                    3
                  </Button>
                  <Button variant="light" size="sm" className="px-2 py-1 rounded fw-bold text-muted">
                    4
                  </Button>
                  <Button variant="light" size="sm" className="px-2 py-1 rounded fw-bold text-muted">
                    5
                  </Button>
                  <span className="px-1 text-muted">...</span>
                  <Button variant="light" size="sm" className="px-2 py-1 rounded fw-bold text-muted">
                    84
                  </Button>
                  <Button variant="light" size="sm" className="p-1 rounded text-muted">
                    <ChevronRight size={16} />
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>

          {/* Invoices Table Card */}
          <Card className="border-0 shadow-sm" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FileText size={20} style={{ color: "#800001" }} />
                  <h5 className="fw-extrabold mb-0" style={{ color: "#0f172a" }}>
                    Invoices
                  </h5>
                </div>

                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <Form.Select
                    size="sm"
                    className="fw-bold"
                    value={selectedInvoiceStatus}
                    onChange={(e) => setSelectedInvoiceStatus(e.target.value)}
                    style={{ borderRadius: "0.5rem", borderColor: "#e2e8f0", width: "120px" }}
                  >
                    <option>All Status</option>
                    <option>Paid</option>
                    <option>Sent</option>
                    <option>Overdue</option>
                  </Form.Select>

                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="d-flex align-items-center gap-1 fw-bold bg-white"
                    style={{ borderRadius: "0.5rem", borderColor: "#e2e8f0", color: "#475569", fontSize: "0.78rem" }}
                  >
                    <Calendar size={14} /> {dateRange}
                  </Button>

                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="d-flex align-items-center gap-1 fw-bold bg-white"
                    style={{ borderRadius: "0.5rem", borderColor: "#e2e8f0", color: "#800001", fontSize: "0.78rem" }}
                  >
                    <Filter size={14} /> Filters
                  </Button>
                </div>
              </div>

              <Table responsive borderless className="align-middle mb-3">
                <thead>
                  <tr className="border-bottom text-muted small" style={{ fontSize: "0.78rem" }}>
                    <th className="py-2 px-2">Invoice #</th>
                    <th className="py-2 px-2">Partner Name</th>
                    <th className="py-2 px-2">Invoice Date</th>
                    <th className="py-2 px-2">Due Date</th>
                    <th className="py-2 px-2">Amount</th>
                    <th className="py-2 px-2">Status</th>
                    <th className="py-2 px-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {INVOICES_LIST.map((item) => (
                    <tr key={item.id} className="border-bottom">
                      <td className="py-3 px-2 fw-extrabold small" style={{ color: "#0f172a" }}>
                        {item.invoiceNo}
                      </td>
                      <td className="py-3 px-2 fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.name}
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.8rem" }}>
                        {item.invoiceDate}
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.8rem" }}>
                        {item.dueDate}
                      </td>
                      <td className="py-3 px-2 fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.amount}
                      </td>
                      <td className="py-3 px-2">
                        <Badge
                          className="px-3 py-1 fw-bold"
                          style={{ borderRadius: "50rem", fontSize: "0.72rem", ...getStatusBadgeStyle(item.status) }}
                        >
                          {item.status}
                        </Badge>
                      </td>
                      <td className="py-3 px-2 text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <Button variant="link" className="p-1 text-muted">
                            <Eye size={15} style={{ color: "#800001" }} />
                          </Button>
                          <Button variant="link" className="p-1 text-muted">
                            <Download size={15} style={{ color: "#800001" }} />
                          </Button>
                          <Button variant="link" className="p-1 text-muted">
                            <Mail size={15} style={{ color: "#800001" }} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <a
                href="#all-invoices"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1 mt-2"
                style={{ color: "#800001" }}
              >
                View All Invoices <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>

        {/* Right Column: Upcoming Renewals & Outstanding Payments */}
        <Col lg={5}>
          {/* Upcoming Renewals Card */}
          <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <RotateCw size={20} style={{ color: "#800001" }} />
                  <h5 className="fw-extrabold mb-0" style={{ color: "#0f172a" }}>
                    Upcoming Renewals
                  </h5>
                </div>
                <a
                  href="#renewals"
                  className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                  style={{ color: "#800001" }}
                >
                  View All <ArrowRight size={14} />
                </a>
              </div>

              <div className="d-flex flex-column gap-3">
                {UPCOMING_RENEWALS.map((item) => (
                  <div key={item.id} className="d-flex align-items-center justify-content-between p-2 rounded-3 border-bottom">
                    <div className="d-flex align-items-center gap-2 min-w-0">
                      <img
                        src={item.logo}
                        alt={item.name}
                        className="rounded-circle object-fit-cover flex-shrink-0"
                        style={{ width: "36px", height: "36px", border: "1.5px solid #F8DBA0" }}
                      />
                      <div className="min-w-0">
                        <div className="fw-extrabold text-truncate mb-0" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                          {item.name}
                        </div>
                      </div>
                      <Badge
                        className="px-2 py-1 fw-bold ms-1 flex-shrink-0"
                        style={{ borderRadius: "50rem", fontSize: "0.68rem", ...getPlanBadgeStyle(item.planType) }}
                      >
                        {item.plan}
                      </Badge>
                    </div>

                    <div className="d-flex align-items-center gap-3 flex-shrink-0">
                      <div className="fw-bold small" style={{ color: "#ea580c", fontSize: "0.78rem" }}>
                        {item.dueDate}
                      </div>
                      <div className="fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.amount}
                      </div>
                      <Badge
                        className="px-2 py-1 fw-bold"
                        style={{ borderRadius: "50rem", fontSize: "0.72rem", backgroundColor: "#fef3c7", color: "#b45309" }}
                      >
                        {item.daysLeft}
                      </Badge>
                    </div>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>

          {/* Outstanding Payments Card */}
          <Card className="border-0 shadow-sm" style={{ borderRadius: "1.25rem" }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FileText size={20} style={{ color: "#800001" }} />
                  <h5 className="fw-extrabold mb-0" style={{ color: "#0f172a" }}>
                    Outstanding Payments
                  </h5>
                </div>
                <a
                  href="#outstanding"
                  className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1"
                  style={{ color: "#800001" }}
                >
                  View All <ArrowRight size={14} />
                </a>
              </div>

              <Table responsive borderless className="align-middle mb-3">
                <thead>
                  <tr className="border-bottom text-muted small" style={{ fontSize: "0.78rem" }}>
                    <th className="py-2 px-2">Partner Name</th>
                    <th className="py-2 px-2">Invoice #</th>
                    <th className="py-2 px-2">Due Date</th>
                    <th className="py-2 px-2">Amount</th>
                    <th className="py-2 px-2 text-end">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {OUTSTANDING_PAYMENTS.map((item) => (
                    <tr key={item.id} className="border-bottom">
                      <td className="py-3 px-2 fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.name}
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.78rem" }}>
                        {item.invoiceNo}
                      </td>
                      <td className="py-3 px-2 fw-bold small text-muted" style={{ fontSize: "0.78rem" }}>
                        {item.dueDate}
                      </td>
                      <td className="py-3 px-2 fw-extrabold" style={{ color: "#0f172a", fontSize: "0.85rem" }}>
                        {item.amount}
                      </td>
                      <td className="py-3 px-2 text-end">
                        <Badge
                          className="px-3 py-1 fw-bold"
                          style={{ borderRadius: "50rem", fontSize: "0.72rem", ...getStatusBadgeStyle(item.status) }}
                        >
                          {item.status}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <a
                href="#all-outstanding"
                className="fw-extrabold text-decoration-none small d-flex align-items-center gap-1 mt-2"
                style={{ color: "#800001" }}
              >
                View All Outstanding <ArrowRight size={14} />
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
